module.exports = "images/enfants_5.5f5e7fb0.png";